export default {
    table: {
        total: 'Total',
        totalFor: 'Total for',
    },
};
